const DEFAULT_LOCATION = {
  lat: 39.635307,
  lng: -101.337891,
};

export default DEFAULT_LOCATION;
